<template>
  <div class="config-field" :class="{ 'config-field--wide': field.type === 'list' }">
    <div class="config-field__label">
      <span class="config-field__name">{{ field.label }}</span>
      <slot name="label-extra" />
    </div>

    <a-input-number
      v-if="field.type === 'number'"
      :value="value"
      :min="field.min"
      :max="field.max"
      :disabled="disabled"
      style="width: 100%"
      @change="onInput"
    />

    <a-select
      v-else-if="field.type === 'boolean'"
      :value="value"
      allow-clear
      :disabled="disabled"
      style="width: 100%"
      @change="onInput"
    >
      <a-select-option value="true">True</a-select-option>
      <a-select-option value="false">False</a-select-option>
    </a-select>

    <a-select
      v-else-if="field.type === 'select'"
      :value="value"
      allow-clear
      show-search
      option-filter-prop="children"
      :disabled="disabled"
      style="width: 100%"
      @change="onInput"
    >
      <a-select-option v-for="option in field.options" :key="String(option)" :value="option">
        {{ option === '' ? '(empty)' : option }}
      </a-select-option>
    </a-select>

    <a-select
      v-else-if="field.type === 'userAgent'"
      :value="value"
      allow-clear
      show-search
      option-filter-prop="children"
      :disabled="disabled"
      style="width: 100%"
      placeholder="Select a user agent"
      @change="onInput"
    >
      <a-select-option
        v-for="option in userAgentSelectOptions"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </a-select-option>
    </a-select>

    <a-textarea
      v-else-if="field.type === 'list'"
      :value="value"
      :rows="3"
      :disabled="disabled"
      @change="onNativeInput"
    />

    <a-input
      v-else
      :value="value"
      :disabled="disabled"
      @change="onNativeInput"
    />

    <div v-if="field.hint" class="config-field__hint">{{ field.hint }}</div>
  </div>
</template>

<script>
  import { buildUserAgentOptions } from '../consts/RenderingConfig.consts';
  import '../styles/rendering-config.css';

  export default {
    name: 'RenderingConfigField',
    props: {
      field: { type: Object, required: true },
      value: { default: null },
      disabled: { type: Boolean, default: false },
      userAgents: { type: Array, default: () => [] },
    },
    computed: {
      userAgentSelectOptions() {
        return buildUserAgentOptions(this.userAgents, this.value);
      },
    },
    methods: {
      onInput(next) {
        this.$emit('input', next);
      },
      onNativeInput(event) {
        const next = event && event.target ? event.target.value : event;
        this.$emit('input', next);
      },
    },
  };
</script>
